angular.module("ricercaADV.components", [])
    .component("ricercaAdv", {
        templateUrl: "ng/components/ricercaADV/ricercaADV.view.html",
        bindings: {
            pressSearch: '&',
            searchFinish: '<'
        },
        controller: RicercaADV,
        controllerAs: "ricercaAdvCtrl"
    })

function RicercaADV(
    $modalService,
    $rootScope,
    $timeout
) {
    var self = this;

    self.$onInit = function () {

        self.supportModel = {
            preventivo: null,
            anno: null,
            contratto: null,
            modulo: null,
            ndg: null,
            convenzione: null
        }

    }

    self.$onChanges = function (changed) {
        if (changed.searchFinish && changed.searchFinish.currentValue) {
            self.loading = false;
        }
    }

    self.search = function () {
        self.loading = true;
        self.pressSearch({
            filter: self.supportModel
        })

    }

    self.enabledConfirm = function (value) {
        self.enabledConfirmButton = !!value;
        self.userSelected = value;
    }

    self.addSubjectSelected = function (subject) {
        $rootScope.disableDoubleClick = false;
        $modalService.closeModal("ricercaAnagrafica-modal");
        self.supportModel.ndg = subject.ndg;
        self.enableModal = false;
        //if (self.supportModel.ndg) {
        self.search();
        //}
    }

    self.closeModal = function () {
        $modalService.closeModal("ricercaAnagrafica-modal");
        self.enableModal = false;
    }

    self.openModalRicercaAnagrafica = function () {
        self.enableModal = true;
        $timeout(function () {

            $modalService.openModal("ricercaAnagrafica-modal");
        }, 500)
    }
}